import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { AuthenticationService } from 'projects/ngx-messaging/src/modules/user/services/authentication.service';

@Injectable()
export class AuthGuard {
  constructor(private authService: AuthenticationService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.checkToken(route);
    if (this.authService.isAuthenticated()) {
      return true;
    }
    if (route.queryParams['signature']) {
      return true;
    }

    const queryParams: {
      dealerId?: string;
      redirect: boolean;
    } = { redirect: true };

    if (route.queryParams['dealerId']) {
      queryParams.dealerId = route.queryParams['dealerId'] as string;
    }

    this.router.navigate(['login'], { queryParams });
    return false;
  }

  checkToken(route: ActivatedRouteSnapshot): void {
    const token = route.queryParams['tkn'] as string;
    if (token) {
      this.authService.loginWithParams(token);
    }
  }
}
